import { getUserMetadata } from "./getUserMetadata";
import { recordConcernVisit } from "./recordConcernVisit";
import { rememberPwaUse } from "./rememberPwaUse";

export const metadataAPI = {
  getUserMetadata,
  recordConcernVisit,
  rememberPwaUse,
};

export type MetadataAPI = typeof metadataAPI;
